import { reactive } from 'vue';
import { useQuery } from 'vue-query';
import { UseQueryOptions } from 'react-query/types';
import QUERY_KEYS from '@/constants/queryKeys';
import useNetwork from '../useNetwork';
import { balancerFarmSubgraphService } from '@/services/balancer/subgraph/balancer-farm-subgraph.service';
import { FlakeCirculates } from '@/services/balancer/subgraph/types';

/**
 * TYPES
 */
type QueryResponse = FlakeCirculates[];

/**
 * Fetch all token lists, should only happen once.
 */
export default function useFlakeCirculatesQuery(
  options: UseQueryOptions<QueryResponse> = {}
) {
  const { networkId } = useNetwork();

  const queryKey = reactive(QUERY_KEYS.FarmPools.FLAKECIRCULATES(networkId));

  const queryFn = async () => {
    return await balancerFarmSubgraphService.flakeCirculates.get({});
  };

  const queryOptions = reactive({
    enabled: true,
    ...options
  });

  return useQuery<QueryResponse>(queryKey, queryFn, queryOptions);
}
